import { isNullOrUndefined, hasValue } from '../../../../../general/js/general-helpers';

export const shouldDisplayRAMembersPortalButton = (buttonCriteria = null, raMemberCriteria = null) => {
    let showRAMembersPortalButton = false;

    if (isNullOrUndefined(raMemberCriteria) || !hasValue(buttonCriteria)) return showRAMembersPortalButton;

    if (hasValue(raMemberCriteria)) {
        if (buttonCriteria === raMemberCriteria) {
            showRAMembersPortalButton = true;
        }
    }

    return showRAMembersPortalButton;
};

export const shouldDisplayRAMembersPortalSection = (buttonCriteria = null, raMemberCriteria = null) => {
    const showRaMemberPortal = shouldDisplayRAMembersPortalButton(buttonCriteria, raMemberCriteria);

    return showRaMemberPortal;
};
